"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _terms = babelHelpers.interopRequireDefault(require("modals/terms"));

var _privacy = babelHelpers.interopRequireDefault(require("modals/privacy"));

var _returns = babelHelpers.interopRequireDefault(require("modals/returns"));

var _class, _descriptor, _descriptor2, _temp;

var ModalMap = {
  TermsOfUse: _terms.default,
  PrivacyPolicy: _privacy.default,
  RefundPolicy: _returns.default
};
var FooterNavigation = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(FooterNavigation, _Component);

  function FooterNavigation() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, FooterNavigation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(FooterNavigation)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "copyrightNotice", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "footerItems", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(FooterNavigation, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("div", {
        id: "contentCopyrightFooter",
        className: "system"
      }, null
      /* FIXME: Social icons need to be made not hard-coded. These also need to link appropriately. */
      , null
      /* <div className='social-icons'>
      {
      [ 'facebook', 'twitter', 'instagram' ].map(name => <img key={name} className="item" src={`/admin/platform/plugins/${require('core-plugin').default}/resources/images/social/${name}.png`}/>)
      }
      </div> */
      , _react.default.createElement("div", {
        className: "footer-link-container"
      }, _react.default.createElement("p", null, this.footerItems.filter(function (item) {
        return !ModalMap[item.id];
      }).map(function (item) {
        return _react.default.createElement("span", {
          key: item.id,
          className: "footer-link-item"
        }, _react.default.createElement("a", {
          target: item.newWindow ? "_blank" : "_self",
          href: item.link,
          "data-id": item.id,
          onClick: _this2.doLegalNoticeLink
        }, item.title));
      }))), _react.default.createElement("p", {
        className: "notice"
      }, this.copyrightNotice, this.footerItems.filter(function (item) {
        return ModalMap[item.id];
      }).map(function (item) {
        return _react.default.createElement("span", {
          key: item.id,
          className: "footer-link-item"
        }, _react.default.createElement("a", {
          target: item.newWindow ? "_blank" : "_self",
          href: item.link,
          "data-id": item.id,
          onClick: _this2.doLegalNoticeLink
        }, item.title));
      })));
    }
  }, {
    key: "doLegalNoticeLink",
    value: function doLegalNoticeLink(event) {
      var which = event.target.dataset.id;

      if (which == 'TermsOfUse' || which == 'PrivacyPolicy' || which == 'RefundPolicy') {
        var mode = this.props.mode[which];

        if (mode == 'Inline') {
          ModalMap[which].show();
          event.preventDefault();
          return false;
        }
      }
    }
  }]);
  return FooterNavigation;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "copyrightNotice", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "footerItems", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doLegalNoticeLink", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doLegalNoticeLink"), _class.prototype)), _class);
exports.default = FooterNavigation;